import React from 'react';
import PropTypes from 'prop-types';
import RestaurantCardHomeComponent from '../../../../components/RestaurantCardHome';

class RestaurantCardHome extends React.Component {
  validateProps({
    name,
    url,
    imageUrl,
    ratingPercent,
    ratingCount,
    priceText,
    locationText,
    isEditions,
    isCard,
    cardSize,
  }) {
    return (
      typeof name === 'string' &&
      typeof url === 'string' &&
      typeof imageUrl === 'string' &&
      typeof ratingPercent === 'number' &&
      typeof ratingCount === 'string' &&
      typeof priceText === 'string' &&
      typeof locationText === 'string' &&
      typeof isEditions === 'boolean' &&
      typeof isCard === 'boolean' &&
      typeof cardSize === 'string'
    );
  }

  componentDidMount() {
    const {
      name,
      url,
      imageUrl,
      ratingPercent,
      ratingCount,
      priceText,
      locationText,
      isEditions,
      isCard,
      cardSize,
    } = this.props;

    if (
      !this.validateProps({
        name,
        url,
        imageUrl,
        ratingPercent,
        ratingCount,
        priceText,
        locationText,
        isEditions,
        isCard,
        cardSize,
      })
    ) {
      throw new Error(`Incorrect prop-types for Storyblok RestaurantCardHome component`);
    }
  }

  render() {
    const {
      name,
      url,
      imageUrl,
      ratingPercent,
      ratingCount,
      priceText,
      locationText,
      isEditions,
      isCard,
      cardSize,
    } = this.props;
    return (
      <RestaurantCardHomeComponent
        name={name}
        url={url}
        imageUrl={imageUrl}
        ratingPercent={ratingPercent}
        ratingCount={ratingCount}
        deliveryFee={{
          presentational: locationText,
        }}
        isEditions={isEditions}
        priceCategory={priceText}
        isCardStyle={isCard}
        cardSize={cardSize}
      />
    );
  }
}

RestaurantCardHome.propTypes = {
  name: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  ratingPercent: PropTypes.number.isRequired,
  ratingCount: PropTypes.string.isRequired,
  priceText: PropTypes.string.isRequired,
  locationText: PropTypes.string.isRequired,
  isEditions: PropTypes.bool.isRequired,
  isCard: PropTypes.bool,
  cardSize: PropTypes.string,
};

RestaurantCardHome.defaultProps = {
  isCard: false,
  cardSize: 'MEDIUM',
};

export default RestaurantCardHome;
